import { EContentOrder, FindUserServiceStrategyEnum, IFindUserServicesFilter, PublishStatusEnum } from 'lingo2-models';
import { IServicesTab } from './models';

export const tabs: IServicesTab[] = [
  { code: 'published', title: 'publish-status.published' },
  { code: 'moderation', title: 'publish-status.moderation' },
  { code: 'archive', title: 'publish-status.archive' },
];

export const filters: { [key: string]: Partial<IFindUserServicesFilter> } = {
  all: {
    use: FindUserServiceStrategyEnum.owned,
  },

  published: {
    use: FindUserServiceStrategyEnum.owned,
    publish_status: [PublishStatusEnum.published],
    order: EContentOrder.date_desc,
  },

  moderation: {
    use: FindUserServiceStrategyEnum.owned,
    publish_status: [PublishStatusEnum.moderation],
    order: EContentOrder.date_desc,
  },

  archive: {
    use: FindUserServiceStrategyEnum.owned,
    publish_status: [PublishStatusEnum.archive],
    order: EContentOrder.date_desc,
  },
};
